import axios from 'axios';

const service = axios.create({
    baseURL: window.CONFIG.FixitCampaignApi+'webshop'
})
// axios.post('/api/campaigns/filter', filter

export default {
    /**
     * Gets all campaings by applied filter
     * @returns {Promise<CampaignCompactListResponse>} array of compactCampaignDto's
     */

     async GetCampaingsByFilter(filter, chainId) {
        Object.assign(filter, {chainId : chainId})
        return await axios.post(`${window.CONFIG.FixitCampaignApi}webshop/get-webshop-campaigns?code=vue`,  filter)
     },

     /**
      * Gets a campaign by provided campaign ID
      * @returns {Promise<CampaignResponse>} campaignDto
      */
     async GetCampaign(args) {
         return await axios.get(`${window.CONFIG.FixitCampaignApi}webshop/get-campaign/${args.chainId}/${args.campaignId}?code=vue`)
     }

}